import { render, staticRenderFns } from "./editClient.vue?vue&type=template&id=44860a94&scoped=true&"
import script from "./editClient.vue?vue&type=script&lang=js&"
export * from "./editClient.vue?vue&type=script&lang=js&"
import style0 from "./editClient.vue?vue&type=style&index=0&id=44860a94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44860a94",
  null
  
)

export default component.exports